import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './tour/home/home.component';

import { TourComponent } from './tour/tour.component';
import { TourStopMapComponent } from './tour/tour-stop-map/tour-stop-map.component';
import { ValidateTourStopGuard } from './tour/guards/validate-tour-stop/validate-tour-stop.guard';


const subRoutes: Routes = [
  {
    path: 'welcome',
    loadChildren: () =>
      import('./welcome-page/welcome-page.module').then(
        (m) => m.WelcomePageModule
      ),
  },
  {
    path: 'choose-stop',
    loadChildren: () =>
      import('./choose-stop/choose-stop.module').then(
        (m) => m.ChooseStopModule
      ),
  },
  // {
  //   path: '**',
  //   canActivate: [ValidateTourStopGuard],
  //   loadChildren: () =>
  //   import('./tour/tour-stop-map/tour-stop-map.module').then(
  //     (m) => m.TourStopMapModule
  //   ),
  // },
  { path: '', component: HomeComponent },
];
const routes: Routes = [
  {
    path: 'es',
    children: subRoutes,
  },
  {
    path: '',
    children: subRoutes,
  },
  // {
  //   path: '**',
  //   canActivate: [ValidateTourStopGuard],
  //   loadChildren: () =>
  //   import('./tour/tour-stop-map/tour-stop-map.module').then(
  //     (m) => m.TourStopMapModule
  //   ),
  // },
  {
    path: '**',
    canActivate: [ValidateTourStopGuard],
    component: TourStopMapComponent
  },
  // {
  //   path: '**',
  //   canActivate: [ValidateTourStopGuard],
  //   component: TourComponent
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
